// export function manageLocalStorage(fieldName, value) {
//     // Verificar si 'value' está definido, lo que indica que queremos establecer un valor.
//     if (value !== undefined) {
//       localStorage.setItem(fieldName, value);
//     } else {
//       // Intentar obtener el valor del campo desde el localStorage.
//       const storedValue = localStorage.getItem(fieldName);
//       return storedValue;
//     }
//   }

export function manageLocalStorage(fieldName, value, dataType) {
    // Verificar si estamos trabajando con un array.
    if (dataType === "array") {
      if (value !== undefined) {
        // Recuperar el array actual, si existe.
        const currentArray = JSON.parse(localStorage.getItem(fieldName) || "[]");
        // Añadir el nuevo valor al array.
        currentArray.push(value);
        // Guardar el array modificado.
        localStorage.setItem(fieldName, JSON.stringify(currentArray));
      } else {
        // Recuperar y devolver el array, si solo se está consultando.
        const storedArray = localStorage.getItem(fieldName);
        return storedArray ? JSON.parse(storedArray) : [];
      }
    } else {
      // Manejar como un valor único (no array).
      if (value !== undefined) {
        localStorage.setItem(fieldName, value);
      } else {
        // Intentar obtener el valor del campo desde el localStorage.
        const storedValue = localStorage.getItem(fieldName);
        return storedValue;
      }
    }
  }
  